import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "removespace",
    standalone: false
})
export class RemoveSpacePipe implements PipeTransform {
  /**
   * This pipe will return string with first character uppercase and remaning lowercase
   * @param value:any
   */
  transform(value: string) {
    return value.trim();
  }
}
